import React from 'react'
import Herosection from '../../Herosection'
import { homeObjThree } from './Data'

function Services() {
    return (
        <div>
            <Herosection {...homeObjThree}/>
        </div>
    )
}

export default Services
